import { DynamicProfileHubBase } from '../DynamicProfileHubBase';
import { ProfileStoreType } from '../DynamicProfileEnums';
import { DynamicWaterwayProfileStore } from './DynamicWaterwayProfileStore';
import { DynamicWaterwayMapStore } from './DynamicWaterwayMapStore';
import { DynamicWaterwayTableStore } from './DynamicWaterwayTableStore';

class DynamicWaterwayHub extends DynamicProfileHubBase {
  /** override fields */
  protected _profileStore: DynamicWaterwayProfileStore | undefined;
  protected _mapStore: DynamicWaterwayMapStore | undefined;
  protected _tableStore: DynamicWaterwayTableStore | undefined;

  /** Use a factory method pattern: create an actor only when it's needed; make it possible to
   *  expand with complexity through inheritance hierarchy of stores if needed */
  public createStore(storeType: ProfileStoreType, option: any = void 0) {
    switch (storeType) {
      case ProfileStoreType.MAP:
        this._mapStore = new DynamicWaterwayMapStore(this);
        this.MapStore!.MapView = option?.mapView;
        this.disposer.Track(this._mapStore);
        break;

      case ProfileStoreType.PROFILE:
        this._profileStore = new DynamicWaterwayProfileStore(this);
        this.disposer.Track(this._profileStore);
        break;

      case ProfileStoreType.TABLE:
        this._tableStore = new DynamicWaterwayTableStore(this);
        this.disposer.Track(this._tableStore);
        break;

      default:
        // console.log(ProfileStoreType[storeType] + ' store type is not supported yet.');
        break;
    }
  }

  /** for compatibility to existing code */
  private _setStore;
  set setStore(setStore) {
    this._setStore = setStore;
  }
  get setStore() {
    return this._setStore;
  }

  private _waterwayStore;
  public get waterwayStore() {
    return this._waterwayStore;
  }
  public set waterwayStore(value) {
    this._waterwayStore = value;
  }
}

export { DynamicWaterwayHub };
